module.exports = __webpack_public_path__ + "img/28.4b1b18e8.png";